module.exports = __webpack_public_path__ + "img/defi.decda38b.png";